// Apolo IDE — Compare Mode toggle (Sprint v4 Epic S1 WS S1.2).
//
// Visual switch + keyboard shortcut indicator. The shortcut listener itself
// lives in useCompareMode — this component only renders the button and
// surfaces ⇧⌘P in the title for discoverability.

import { Columns3 } from 'lucide-react';

export default function CompareModeToggle({ active, onToggle, count }) {
  return (
    <button
      type="button"
      onClick={() => onToggle?.(!active)}
      aria-pressed={active ? 'true' : 'false'}
      aria-label="Alternar Compare Mode"
      title="Compare Mode (Shift+Cmd+P)"
      className={`inline-flex h-9 shrink-0 items-center gap-1 rounded-md border px-2 text-xs transition ${
        active
          ? 'border-apolo-accent bg-apolo-accent/15 text-apolo-accent'
          : 'border-apolo-borderSubtle text-apolo-textSecondary hover:bg-apolo-surface2'
      }`}
    >
      <Columns3 size={11} aria-hidden="true" />
      <span>Compare</span>
      {active && typeof count === 'number' && count > 0 ? (
        <span className="ml-1 rounded-full bg-apolo-bg/40 px-1.5 py-0.5 text-[10px]" aria-label={`${count} modelos selecionados`}>
          {count}
        </span>
      ) : null}
    </button>
  );
}
